import { SnippetPreview } from '@/components/snippet';
import { useWorkspace } from '@/features/workspaces/hooks';
import { StepPageActions } from '@/global/components';
import { DataSource, DataSourceCodeConfig } from '@/models/dataSource';
import { RootState } from '@/reducers';
import { useGetDataSourceSetupQuery } from '@/services/dataSources';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { generateCodeScript } from '../helper';

type SnippetPreviewStepProps = {
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  onCancel?: VoidFunction;
};

export const SnippetPreviewStep: FC<SnippetPreviewStepProps> = ({ onNextStep, onPrevStep }) => {
  const workspace = useWorkspace();

  const dataSource = useSelector((state: RootState) => state.dataSources.edit?.dataSource) as Partial<DataSource<DataSourceCodeConfig>> | undefined;
  const dataSourceType = dataSource.type;

  const { data: setupData } = useGetDataSourceSetupQuery(
    {
      workspaceId: workspace.id,
      dataSourceId: dataSource?.id || '',
    },
    {
      skip: !dataSource?.id,
    }
  );

  const script = generateCodeScript(setupData, dataSourceType);

  const handleNextStep = () => {
    onNextStep();
  };

  return (
    <>
      <div className='mt-6 h-auto rounded-lg border border-solid border-gray-200 text-left'>
        <SnippetPreview script={script} type={dataSourceType} ctaRight />
      </div>

      <StepPageActions
        primaryButton={{
          text: 'COMMON.confirm',
          onClick: handleNextStep,
        }}
        secondaryButton={{
          text: 'COMMON.cancel',
          onClick: onPrevStep,
        }}
      />
    </>
  );
};
